import { NOTIFICATION_ADD } from './mutation-types'
import constant from '../constant'

export default {
  state: {
    notifications: [],
    /** 通知を削除 */
    deleteNotification: function (key) {
      var length = this.notifications.length
      for (var i = length - 1; i >= 0; i--) {
        var notification = this.notifications[i]
        if (notification.key === key) {
          this.notifications.splice(i, 1)
        }
      }
    }
  },
  getters: {
    notifications: state => {
      return state.notifications
    }
  },
  actions: {
    /** 通知を追加 */
    [NOTIFICATION_ADD] ({state, commit}, params) {
      var data = {}
      var sleep = constant.notifyShowTime.normal
      if (params) {
        data = params.data
        if (params.sleep) {
          sleep = params.sleep
        }
      }
      var key = Math.floor(new Date().getTime())
      data['key'] = key
      state.notifications.unshift(data) // 新しい通知を上に出す
      setTimeout(() => {
        state.deleteNotification(key)
      }, sleep)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notification.js